import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { siteStats } from '@/mocks/siteContent';

const hotTags = ['顶流恋情', '解约风波', '版权分成', '综艺剪辑', '双代言'];

export default function Hero() {
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const onSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/collections?q=${encodeURIComponent(q)}` : '/collections');
  };

  return (
    <section className="relative w-full overflow-hidden -mt-16 md:-mt-20">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20theater%20stage%20with%20warm%20coral%20and%20golden%20spotlights%20cutting%20through%20haze%2C%20dark%20moody%20background%20with%20blurred%20bokeh%20lights%2C%20stylized%20cinematic%20atmosphere%2C%20minimal%20composition%2C%20high%20detail&width=1600&height=900&seq=guagua-hero-main&orientation=landscape"
          alt="看瓜爆料 合集汇总专题首屏背景"
          title="看瓜爆料 合集汇总 一次看个够"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/85"></div>
      </div>

      <div className="relative w-full px-4 md:px-10 pt-24 pb-20 md:pt-32 md:pb-28">
        <div className="max-w-4xl mx-auto text-center animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/10 border border-background-50/25 text-background-50 text-xs label-font mb-6">
            <i className="ri-fire-line text-accent-400"></i>
            320+ 个专题已打包整理
          </span>

          <h1 className="font-heading font-black text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight">
            看瓜爆料 · 合集汇总专题
          </h1>
          <p className="mt-5 text-base md:text-lg text-background-100/90 leading-relaxed max-w-2xl mx-auto">
            把零散的瓜料按「事件、人物、时间线」打包成专题合集，
            从起因到后续一次看个够，省去东翻西找的麻烦。
          </p>

          <form onSubmit={onSearch} className="mt-8 max-w-2xl mx-auto">
            <div className="flex flex-col sm:flex-row gap-3 p-2 rounded-lg bg-background-50/95 border border-background-50/40">
              <label className="flex-1 flex items-center gap-2 px-3">
                <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
                  <i className="ri-search-line"></i>
                </span>
                <span className="sr-only">搜索合集专题</span>
                <input
                  type="search"
                  name="q"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索事件、人物或关键词，如「解约」「剪辑」"
                  className="w-full h-11 bg-transparent border-0 text-sm label-font text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
                />
              </label>
              <button
                type="submit"
                className="h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm label-font whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                找合集
              </button>
            </div>
          </form>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
            <span className="text-xs text-background-100/70 label-font">热搜：</span>
            {hotTags.map((tag) => (
              <button
                key={tag}
                type="button"
                onClick={() => navigate(`/collections?q=${encodeURIComponent(tag)}`)}
                className="px-3 py-1 rounded-full border border-background-50/30 text-xs label-font text-background-100 hover:bg-background-50/15 hover:border-background-50/60 transition-colors cursor-pointer"
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-14 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
          {siteStats.map((stat) => (
            <div
              key={stat.label}
              className="text-center py-4 rounded-lg bg-background-50/10 border border-background-50/20"
            >
              <div className="font-heading font-bold text-2xl md:text-3xl text-accent-400">
                {stat.value}
              </div>
              <div className="mt-1 text-xs md:text-sm label-font text-background-100/80">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}